const initialState = {
  loading: false,
  open: false,
  id: '',
  text: '',
  value: '',
  tabelaInsumoMes: [],
  excluido: false
}

export function tabelaInsumoMes(state = initialState, action) {
  switch (action.type) {
    case 'FETCHED_ALL_TABELA_INSUMO_MES':
      return {
        ...state,
        tabelaInsumoMes: action.tabelaInsumoMes
      }
    case 'MES_CLEAR':
      return initialState
    default:
      return state
  }
}
